import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Toolbar from "@material-ui/core/Toolbar";
import { navigateTo } from "../../redux/actions";
import AutoComplete from "./autocomplete";
import { roles } from "../../utils/Objects";
import {
  getStatusList,
  getTimeFrameList,
  isAdmins,
  isClinics,
  isNonPaitentsClinic,
  isPaitents,
  isUsers,
} from "../../utils/CFuncs";
import { setFilterStatus, setSearchTxt, setTimeFrame } from "../../redux/actions/FilterAction";
import Search from "./Search";
import Select from "./Select";

class Header extends PureComponent {
  constructor(props) {
    super(props);
   
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleTimeframeChange = this.handleTimeframeChange.bind(this);
    };
  

    handleStatusChange(e){
      this.props.setFilterStatus(e.target.value)
    }
    handleTimeframeChange(e){
      this.props.setTimeFrame(e.target.value)
    }

  render() {
    return (
      <div style={style.container}>
      <Search  />
      <Select text={"status"} list={getStatusList()} onChange={this.handleStatusChange} value={this.props.status}/>
      {isPaitents() && <Select text={"timeframe"} list={getTimeFrameList()} onChange={this.handleTimeframeChange} value={this.props.timeframe}/>} 
      </div>
    );
  }
}

const style = {
  container:{
    width:"75vw",
    display:"flex",
    justifyContent: "space-between",
    paddingBottom: "2rem"

  }
}
const mapStateToProps = (state) => ({
  status: state.filter.status,
  timeframe: state.filter.timeframe
});

const mapDispatchToProps = {
  navigateTo,
  setFilterStatus,
  setSearchTxt,
  setTimeFrame
}




  export default connect(mapStateToProps, mapDispatchToProps)(Header);